import { render, staticRenderFns } from "./ListIndustrialProperties.vue?vue&type=template&id=d97c7160"
import script from "./ListIndustrialProperties.vue?vue&type=script&lang=js"
export * from "./ListIndustrialProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports